/** How often a run list refetches while one of its runs is still running. */
const ACTIVE_RUN_POLL_MS = 3000;
/** How often a run list looks for new runs otherwise. */
const NEW_RUNS_POLL_MS = 10_000;

/**
 * The run list's refetch interval. Fast while anything in it is still
 * running, so statuses move on. Otherwise slow to pick up new runs, or not
 * at all when the list cannot gain any (`canGainRuns` false, e.g. a date
 * range that has ended).
 *
 * "Running" counts both the loaded rows and `runningCount`, the server's
 * count of running runs before the run-type filter: with "Running" unticked
 * none are loaded, yet one may still finish into a shown kind. Null when the
 * server did not say; the rows decide alone then.
 *
 * `runs` is undefined until the list has loaded once. It polls slowly then
 * even when it cannot gain runs: retries and focus refetches are off
 * app-wide, so a failed first request would otherwise never be repeated.
 */
export function agentRunsRefetchInterval(
  runs: readonly { status: string }[] | undefined,
  canGainRuns: boolean,
  runningCount: number | null = null,
): number | false {
  if (runs === undefined) return NEW_RUNS_POLL_MS;
  const anyRunning =
    (runningCount ?? 0) > 0 || runs.some((run) => run.status === 'running');
  if (anyRunning) return ACTIVE_RUN_POLL_MS;
  return canGainRuns ? NEW_RUNS_POLL_MS : false;
}
